/*
    useFirebase
    ---
    Provides common Firebase services.

*/

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';

let firebaseApp, database, firebaseStorage, auth;

const initializeFirebase = (firebaseConfig) => {
    if (!firebaseApp) {
        console.log(`Initialize Firebase`);
        firebaseApp = initializeApp(firebaseConfig);

        database = getDatabase(firebaseApp);
        firebaseStorage = getStorage(firebaseApp);
        auth = getAuth(firebaseApp);
    }
    return firebaseApp;
};

const useFirebase = () => {
    if (!firebaseApp) {
        throw new Error('Firebase has not been initialized. Call initializeFirebase() with your config before attempting to useFirebaseApp.');
    }

    return {
        firebaseApp,
        database,
        auth,
        firebaseStorage,
    };
};

export { initializeFirebase, useFirebase };
